<template>
  <router-switch route-name="QrGifts">
    <v-container fluid>
      <v-card class="sv-card pa-4">
        <v-row no-gutters>
          <data-table
            ref="table-hoc"
            v-model="selected"
            :height-offset="252"
            :filters.sync="filters"
            :schema="filterSchema"
            :headers="headers"
            :count="count"
            :loading="loading"
            :items="items"
            :data-table-props="{
              showSelect: true
            }"
            @fetch="loadItems"
          >
            <template #before-filter>
              <v-menu :rounded="false" offset-y class="mr-4 flex-grow-0">
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    color="primary"
                    :disabled="selected.length == 0"
                    depressed
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Групповые действия
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="onChangeNames">
                    <v-list-item-title>Изменить названия</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="onChangeTags">
                    <v-list-item-title>Изменить тэги</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template #after-filter>
              <toggle-button
                v-model="given"
                big
                :items="[
                  { id: 0, name: 'Все' },
                  { id: 1, name: 'Отдано' },
                  { id: 2, name: 'Не отдано' }
                ]"
                class="ml-4"
              />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template #item.node_created_at="{ item: { node_created_at } }">
              {{ formatDateTime(node_created_at) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template #item.title="{ item: { title, id } }">
              <router-link
                :to="{ name: 'QrGiftsEdit', params: { id } }"
                class="sv-toggler"
                >{{ title }}</router-link
              >
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template #item.tags="{ item: { tags } }">
              <badge
                v-for="(tag, tagIndex) in tags"
                :key="tagIndex"
                :text="tag"
              />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template #item.gadget_given="{ item: { gadget_given } }">
              <div class="d-flex justify-center">
                <v-checkbox
                  v-if="gadget_given == '1'"
                  readonly
                  :input-value="true"
                />
                <v-checkbox v-else readonly :input-value="false" />
              </div>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template #item.contact_data="{ item: { contact_data } }">
              <div v-html="nl2br(contact_data)" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template #item.actions="{ item }">
              <action-col>
                <action-col-btn
                  v-if="$canViewHistory()"
                  :id="`btn-view-history-${item.id}`"
                  tooltip="История изменений"
                  @click="showHistory(item.id)"
                >
                  mdi-history
                </action-col-btn>
                <action-col-btn
                  v-if="$canEdit()"
                  :id="`btn-edit-${item.id}`"
                  tooltip="Изменить"
                  :to="{ name: 'QrGiftsEdit', params: { id: item.id } }"
                >
                  mdi-pencil-outline
                </action-col-btn>
                <action-col-btn
                  v-else
                  :id="`btn-view-${item.id}`"
                  tooltip="Просмотр"
                  :to="{ name: 'QrGiftsView', params: { id: item.id } }"
                >
                  mdi-eye-outline
                </action-col-btn>
                <action-col-btn
                  :id="`btn-www-${item.id}`"
                  tooltip="Просмотр на сайте"
                  :href="`https://soft.sc/qr/${item.node_name}`"
                  target="checking-www"
                >
                  mdi-monitor
                </action-col-btn>
              </action-col>
            </template>
          </data-table>

          <mass-assignment-tags
            v-if="$canEdit()"
            v-model="changeTagsDialog"
            @apply="onChangeTagsExecute"
          />

          <mass-assignment-names
            v-if="$canEdit()"
            v-model="changeNamesDialog"
            @apply="onChangeNamesExecute"
          />

          <history-object-modal
            v-if="$canViewHistory()"
            v-model="historyDialog"
            :item-object-id="selectedItemId"
            scope-name="Node"
          />
        </v-row>
      </v-card>
    </v-container>
  </router-switch>
</template>
<script>
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import NotificationMixin from "@/mixins/NotificationMixin";
import DialogMixin from "@/mixins/DialogMixin";
import QueryMixin from "@/mixins/QueryMixin";
import ResizeMixin from "@/mixins/ResizeMixin";

import SearchFilter from "@/components/Filters/SearchFilter";
import SelectFilter from "@/components/Filters/SelectFilter";
import DatetimeRangeFilter from "@/components/Filters/DatetimeRangeFilter";
import DataTable from "@/components/DataTable.vue";
import Badge from "@/components/Badge.vue";
import ToggleButton from "@/components/ToggleButton.vue";
import Repository from "@/api/special/qr-gifts.js";
import HistoryObjectModal from "@/components/HistoryObjectModal.vue";
import MassAssignmentTags from "./MassAssignmentTags.vue";
import MassAssignmentNames from "./MassAssignmentNames.vue";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  components: {
    DataTable,
    ToggleButton,
    MassAssignmentTags,
    MassAssignmentNames,
    HistoryObjectModal,
    Badge
  },
  mixins: [
    CheckPermissionMixin,
    NotificationMixin,
    DialogMixin,
    QueryMixin,
    ResizeMixin
  ],
  data: () => ({
    selected: [],
    given: 0,
    selectedItemId: null,
    count: 0,
    options: {},
    loading: false,
    editDialog: false,
    filterDialog: false,
    historyDialog: false,
    changeTagsDialog: false,
    changeNamesDialog: false,
    filters: {},
    items: [],
    tags: []
  }),
  computed: {
    formatDateTime() {
      return date => (date ? moment(date).format("DD.MM.yyyy HH:mm") : "");
    },
    headers() {
      return [
        { text: "Номер", value: "ident" },
        { text: "Название", value: "title" },
        { text: "Тэги", value: "tags" },
        { text: "Отдано", value: "gadget_given" },
        { text: "Имя", value: "contact_name" },
        { text: "Компания", value: "contact_company" },
        { text: "Контакты", value: "contact_data" },
        { text: "Дата создания", value: "node_created_at" },
        { text: "Количество посещений", value: "visit_cnt" },
        { text: "Последнее посещение", value: "visit_last" },
        {
          text: "Действия",
          value: "actions",
          sortable: false,
          align: "center",
          width: "155px"
        }
      ];
    },
    filterSchema() {
      const { tags } = this;
      return {
        residentData: {
          filters: {
            ident: {
              component: SearchFilter,
              title: "Номер",
              filterBind: { showMethod: false, like: false }
            },
            title: {
              component: SearchFilter,
              title: "Название",
              filterBind: { showMethod: true }
            },
            tags: {
              component: SelectFilter,
              title: "Тэги",
              filterBind: { items: tags, valueItem: "term", textItem: "value" }
            },
            gadget_given: {
              component: SelectFilter,
              title: "Отдано",
              filterBind: {
                items: [
                  { id: 1, title: "Да" },
                  { id: 0, title: "Нет" }
                ],
                valueItem: "id",
                textItem: "title"
              }
            },
            contact_name: {
              component: SearchFilter,
              title: "Имя",
              filterBind: { showMethod: true }
            },
            contact_company: {
              component: SearchFilter,
              title: "Компания",
              filterBind: { showMethod: true }
            },
            contact_data: {
              component: SearchFilter,
              title: "Контакты",
              filterBind: { showMethod: true }
            },
            node_created_at: {
              component: DatetimeRangeFilter,
              title: "Дата создания"
            },
            visit_last: {
              component: DatetimeRangeFilter,
              title: "Последнее посещение"
            }
          }
        }
      };
    }
  },
  watch: {
    given() {
      this.emitFetch();
    }
  },
  methods: {
    async loadItems(params) {
      try {
        this.loading = true;

        if (this.given == 1) {
          params.filters.gadget_given = { items: [1], inverse: false };
        } else if (this.given == 2) {
          params.filters.gadget_given = { items: [0], inverse: false };
        } else {
          params.filters.gadget_given = undefined;
        }

        const { data } = await Repository.getList(params);
        this.tags = data.tags;
        this.items = data.items;
        this.count = data.count;
        this.$store.commit("setChildrenNodesCache", data.childrenCache);
      } finally {
        this.loading = false;
      }
    },
    editItem(id) {
      this.selectedItemId = id;
      this.editDialog = true;
    },
    emitFetch() {
      this.$refs["table-hoc"].fetchData();
    },
    nl2br(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    showHistory(id) {
      this.selectedItemId = id;
      this.historyDialog = true;
    },
    onChangeTags() {
      this.changeTagsDialog = true;
    },
    onChangeNames() {
      this.changeNamesDialog = true;
    },
    async onChangeTagsExecute(e) {
      try {
        const payload = cloneDeep(e);
        payload.selected = this.selected.map(item => item.id);

        this.loading = true;

        const { data } = await Repository.tagsMassUpdate(payload);

        this.sendAlert(data.alert);

        this.selected = [];

        this.$store.dispatch("fetchProfile");

        this.emitFetch();
      } finally {
        this.loading = false;
      }
    },
    async onChangeNamesExecute(e) {
      try {
        const payload = cloneDeep(e);
        payload.selected = this.selected.map(item => item.id);

        this.loading = true;

        const { data } = await Repository.namesMassUpdate(payload);

        this.sendAlert(data.alert);

        this.selected = [];

        this.$store.dispatch("fetchProfile");

        this.emitFetch();
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../styles/branding.scss";
.sv-toggler {
  text-decoration: none !important;
  display: inline;
  line-height: 110%;
  color: #2196f3;
  border-bottom: 1px dashed #2196f3;
  cursor: pointer;
}
</style>
